import { render } from "./CameraIris.vue?vue&type=template&id=12f3612f"
import script from "./CameraIris.vue?vue&type=script&lang=js"
export * from "./CameraIris.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__